<h2>{{ 'general.api_registration_user_title' | translate }}</h2>
<form class="flex flex-column" [formGroup]="form" autocomplete="off" (ngSubmit)="submit()">
  <mat-form-field appearance="outline" class="no-hint">
    <mat-label>{{ 'general.api_registration_user_first_name' | translate }}</mat-label>
    <input matInput type="text" [formControlName]="'firstName'" autocomplete="off">
  </mat-form-field>
  <mat-form-field appearance="outline" class="no-hint">
    <mat-label>{{ 'general.api_registration_user_last_name' | translate }}</mat-label>
    <input matInput type="text" [formControlName]="'lastName'" autocomplete="off">
  </mat-form-field>
  <app-phone-input *ngIf="form && form.controls" [label]="'general.api_registration_user_phone'"
                   [(phoneNr)]="form.controls['phoneNr'].value" [disabled]="isSameEmail"></app-phone-input>
  <mat-form-field appearance="outline"
                  [ngClass]="!form.hasError('pattern', 'email') && !form.hasError('alreadyExists', 'email') && !showEmailExistsError ? 'no-hint' : 'responsive-hint'">
    <mat-label>{{ 'general.api_registration_user_email' | translate }}</mat-label>
    <input matInput type="text" [formControlName]="'email'" (keyup)="checkEmail(); showEmailExistsError && cleanUpEmailValidation()" autocomplete="off">
    <mat-error *ngIf="form.hasError('pattern', 'email')">{{ 'general.api_general_email_hint' | translate }}</mat-error>
    <mat-error *ngIf="showEmailExistsError">{{ 'general.api_users_user_email_already_exists' | translate }}</mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" [ngClass]="{'no-hint': !form.hasError('pattern', 'password'), 'responsive-hint': form.hasError('pattern', 'password')}" *ngIf="!isSameEmail">
    <mat-label>{{ 'general.api_registration_user_password' | translate }}</mat-label>
    <input matInput type="password" [formControlName]="'password'" autocomplete="off">
    <mat-error *ngIf="form.hasError('pattern', 'password')">{{ 'general.api_general_password_hint' | translate }}</mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" [ngClass]="!form.hasError('passwordMismatch') ? 'no-hint' : 'responsive-hint'" *ngIf="!isSameEmail">
    <mat-label>{{ 'general.api_registration_user_password_repeat' | translate }}</mat-label>
    <input matInput type="password" [formControlName]="'passwordRepeat'" autocomplete="off">
    <mat-error *ngIf="form.hasError('passwordMismatch')">{{ 'general.api_general_passwords_should_match' | translate }}</mat-error>
  </mat-form-field>
  <div class="flex flex-row" *ngIf="termsAndConditionsLink">
    <mat-checkbox [formControlName]="'agreedToTermsAndConditions'"/>
    <span class="align-left">
      {{ 'general.api_registration_terms_and_conditions_text' | translate }}
      <app-link [link]="'general.api_registration_terms_and_conditions_link_text'" [wrap]="true" [textAddition]="true"
                (linkClicked)="openTermsAndConditions()"/>
    </span>
  </div>
  <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || isLoading">
    <mat-spinner [diameter]="24" color="accent" *ngIf="isLoading"></mat-spinner>
    <ng-container *ngIf="!isLoading">{{ 'general.api_registration_user_submit' | translate }}</ng-container>
  </button>
  <button mat-button type="button" [disabled]="isLoading" [routerLink]="'/login'">
    {{ 'general.api_registration_user_cancel' | translate }}
  </button>
  <div class="top-spacer-x2 align-left">
    {{ 'general.api_registration_user_already_have_account' | translate }}
  </div>
  <button mat-stroked-button color="primary" type="button" [disabled]="isLoading" [routerLink]="'/login'">
    {{ 'general.api_general_sign_in' | translate }}
  </button>
</form>
